import React from "react";

import BootStrapCustomCarousel from "../../component/Carousel/bootStrapCarousel";
import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";

import 'bootstrap/dist/css/bootstrap.min.css';

const Books: React.FC = () => {
  

  return (
    <Jumbotron
      flexDirection="column"
      justifyContent="center"
      textAlign="center"
      width="100%"
      margin="20px 0"
    >
      <Text text="BOOKS" fs="60px" fontWeight="bold" />
      <BootStrapCustomCarousel />
      <div id="connectMe"/>
    </Jumbotron>
  );
};

export default Books;
